export default [
  {
    path: '/admin',
    name: 'admin-home',
    component: () => import('@/views/admin/Home.vue'),
    meta: {
      pageTitle: 'Home admin',
      breadcrumb: [
        {
          text: 'Home',
          active: true,
        },
      ],
      resource: 'AdminHome',
      action: 'read',
    },
  },
  {
    path: '/slider',
    name: 'slider',
    component: () => import('@/views/admin/Slider.vue'),
    meta: {
      pageTitle: 'Список слайдеров',
      breadcrumb: [
        {
          text: 'Список слайдеров',
          active: true,
        },
      ],
      resource: 'Sliders',
      action: 'read',
    },
  },
  {
    path: '/second-page',
    name: 'second-page',
    component: () => import('@/views/admin/SecondPage.vue'),
    meta: {
      pageTitle: 'Second Page',
      breadcrumb: [
        {
          text: 'Second Page',
          active: true,
        },
      ],
      resource: '*',
      action: 'read',
    },
  },
  {
    path: '/menus',
    name: 'menus',
    component: () => import('@/views/admin/menus-list/MenusList.vue'),
    meta: {
      pageTitle: 'Список меню',
      breadcrumb: [
        {
          text: 'Список меню',
          active: true,
        },
      ],
      resource: 'Menus',
      action: 'read',
    },
  },

  // *===============================================---*
  // *--------- BEGIN USER -------------------------------------------*
  // *===============================================---*
  {
    path: '/admin/users/list',
    name: 'admin-users-list',
    component: () => import('@/views/admin/user/users-list/UsersList.vue'),
    meta: {
      resource: 'Users',
      action: 'read',
    },
  },
  // *===============================================---*
  // *--------- END USER -------------------------------------------*
  // *===============================================---*

  // *===============================================---*
  // *--------- BEGIN ORDER -------------------------------------------*
  // *===============================================---*
  {
    path: '/admin/orders/list',
    name: 'admin-orders-list',
    component: () => import('@/views/admin/orders/OrdersList.vue'),
    meta: {
      resource: 'Orders',
      action: 'read',
    },
  },
  // *===============================================---*
  // *--------- END ORDER -------------------------------------------*
  // *===============================================---*

  // *===============================================---*
  // *--------- BEGIN REPORT -------------------------------------------*
  // *===============================================---*
  {
    path: '/admin/report',
    name: 'admin-report',
    component: () => import('@/views/admin/report/Index.vue'),
    meta: {
      resource: 'Report',
      action: 'read',
    },
  },
  // *===============================================---*
  // *--------- END REPORT -------------------------------------------*
  // *===============================================---*

]
